'use client'

import React, { useEffect } from 'react'
import { useRollbar } from '@rollbar/react'
import { NotAvailable } from '@components/errors/notAvailable'

export default function Error({ error }: { error: Error }) {
  const rollbar = useRollbar()

  useEffect(() => {
    rollbar.error('overview_header', { exception: error })
  }, [error])

  return <NotAvailable />
}
